import UpdateJobPositionOrAreaModal from './UpdateJobPositionOrAreaModal'

export default UpdateJobPositionOrAreaModal
